import { Component, ChangeDetectionStrategy } from "@angular/core";
import { LoginBase } from "./login.base";
import { NgClass } from "@angular/common";
import { MatCard, MatCardContent, MatCardHeader } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";
import { FormRoot, FormField } from "@angular/forms/signals";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { MatCheckbox } from "@angular/material/checkbox";
import { RouterLink } from "@angular/router";
import { MatButton } from "@angular/material/button";

@Component({
  templateUrl: "./login.html",
  styleUrls: ["./login.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    MatCard,
    MatCardHeader,
    MatIcon,
    TranslocoPipe,
    MatCardContent,
    FormRoot,
    FormField,
    MatFormField,
    MatLabel,
    MatCheckbox,
    RouterLink,
    MatInput,
    MatButton
  ]
})
export class Login extends LoginBase {
}
